import { useCallback } from 'react'

import { DrawingParameterCircle, DrawingType } from '@editor/interfaces/drawing'
import { EditorPanelItem, ElementsPanelConfig } from '@editor/interfaces/editor'
import { removeDrawings } from '@editor/pages/projects/blueprint-editor/store/drawings'
import { getDrawingsOfType } from '@editor/services/Drawing'
import { RootState, useAppDispatch } from '@editor/store/app'
import { resetElement } from '@editor/store/tool'
import { useSelector } from 'react-redux'

import { getLastCount } from '../../../utils'
import { reset } from '../store'

const useDrawingsPanel = (): ElementsPanelConfig => {
  // Store
  const dispatch = useAppDispatch()
  const drawings = useSelector((state: RootState) => state.blueprint.drawings.document.drawings)
  const workingCirclePoint = useSelector((state: RootState) => state.bpToolCircle.workingCirclePoint)

  return {
    getPanelItems: useCallback(
      (parent?: EditorPanelItem['item']): EditorPanelItem[] => {
        if (parent) return [] as EditorPanelItem[]

        const results: EditorPanelItem[] = getDrawingsOfType<DrawingParameterCircle>(
          drawings,
          DrawingType.Circle,
          [],
        ).map((item, index) => ({
          key: `tool-circle-drawing-${item.drawing_parameters.uuid}`,
          name: item.name || `円 ${index + 1}`,
          item,
          onDelete: () => {
            dispatch(removeDrawings([item.drawing_parameters.uuid]))
            dispatch(resetElement(item.drawing_parameters.uuid))
          },
        }))

        if (workingCirclePoint) {
          results.push({
            key: 'tool-circle-working-panel-item',
            name: `円 ${
              getLastCount(
                drawings.map((p) => p.name),
                '円',
              ) + 1
            }`,
            isWorking: true,
            onDelete: () => dispatch(reset()),
          })
        }

        return results
      },
      [drawings, workingCirclePoint, dispatch],
    ),
  }
}

export default useDrawingsPanel
